import { AnimatePresence } from 'framer-motion';
import { Box } from '@/ui';
import { printVisibility } from '../../lib/printStyles';
import { getStyleById, type PatternStyle } from '../../lib/theme';
import type { BackgroundProps } from './Background';

export const PatternBackground = ({ themeId }: BackgroundProps) => {
  const sceneStyle = getStyleById(themeId ?? '');
  const pattern = sceneStyle as PatternStyle | undefined;

  let background = pattern?.gradient ?? 'white';

  // use colors array to create a gradient if available
  if (pattern?.colors && pattern.colors.length >= 2) {
    background = `linear-gradient(${pattern.direction ?? 180}deg, ${pattern.colors[0]} 0%, ${pattern.colors[1]} 100%), #FFF`;
  }

  return (
    <Box
      inset="0"
      pointerEvents="none"
      pos="fixed"
      sx={printVisibility.hide()}
      zIndex={-1}
      style={{
        background: background,
      }}
    >
      {pattern?.patternId && pattern.patternId !== 'none' && (
        <AnimatePresence>
          <Box
            inset="0"
            pointerEvents="none"
            pos="fixed"
            zIndex={-1}
            style={{
              backgroundImage: `url(/styles/patterns/${pattern?.patternId})`,
              backgroundRepeat: 'repeat',
              backgroundSize: pattern?.patternSize ?? '300px',
              color: pattern?.patternColor ?? 'rgba(255, 255, 255, 1)',
              opacity: 0.5,
            }}
          />
        </AnimatePresence>
      )}
    </Box>
  );
};
